module.exports = __webpack_public_path__ + "media/images/pages/who_we_are/Nathalie-Smith-7a4475806f05310626534a0b4c690726.png";